module.exports = __webpack_public_path__ + "img/SIB.082a7cb6.svg";